var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 2.66683C8.6901 2.66683 2.66634 8.7014 2.66634 15.9932C2.66634 23.2989 8.70408 29.3335 15.9997 29.3335C23.3092 29.3335 29.333 23.2989 29.333 15.9932C29.333 8.7014 23.2953 2.66683 15.9997 2.66683Z",
    fill: "#282829",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0605 10.5873C19.4099 10.2521 19.4099 9.67936 19.0465 9.31616C18.739 9.02282 18.1241 9.03679 17.7886 9.35807L12.0304 14.8339C11.3596 15.4485 11.3596 16.5102 12.0304 17.1388L17.7886 22.6006C18.166 22.9498 18.6971 22.9778 19.0465 22.6425C19.4099 22.3073 19.4099 21.7206 19.0605 21.3853L13.3721 15.9933L19.0605 10.5873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.0839a2f8b66eae55446c67d8cf4fd720.svg";
export { ForwardRef as ReactComponent };